import { render } from "./contentCreatePersonModalDesktop.vue?vue&type=template&id=20d62571"
import script from "./contentCreatePersonModalDesktop.vue?vue&type=script&lang=js"
export * from "./contentCreatePersonModalDesktop.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__